import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const ModifyChannel = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <rect x="2" y="8" width="8" height="8" rx="2" fill={getColor(color, isColorInherited)} />
    <circle cx="19" cy="12" r="3" fill={getColor(color, isColorInherited)} />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 8C15.6569 8 17 6.65685 17 5C17 3.34315 15.6569 2 14 2C12.3431 2 11 3.34315 11 5C11 6.65685 12.3431 8 14 8ZM14 6C14.5523 6 15 5.55228 15 5C15 4.44772 14.5523 4 14 4C13.4477 4 13 4.44772 13 5C13 5.55228 13.4477 6 14 6Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 23C15.6569 23 17 21.6569 17 20C17 18.3431 15.6569 17 14 17C12.3431 17 11 18.3431 11 20C11 21.6569 12.3431 23 14 23ZM14 21C14.5523 21 15 20.5523 15 20C15 19.4477 14.5523 19 14 19C13.4477 19 13 19.4477 13 20C13 20.5523 13.4477 21 14 21Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M7 12H19M5 6.5V6C5 5.44772 5.44772 5 6 5H12M5 18V19C5 19.5523 5.44772 20 6 20H12"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="2"
    />
  </SvgIcon>
);
